import React, { useEffect, useContext, useState } from "react";
import { signOut } from 'aws-amplify/auth';
import { useNavigate } from "react-router-dom";
import { useSnackbar } from 'notistack';
import { ProductContext } from '../../ProductProvider';
import Preloader from '../../components/Preloader/Preloader';

export default function LogoutPage() {
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const { loggedUser, setLoggedUser } = useContext(ProductContext);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        if (loggedUser.isAuthenticated) {
            handleSignOut();
        } else {
            navigate("/login");
        }
    }, [loggedUser]);

    const handleSignOut = async () => {
        try {
            setLoaded(false);
            await signOut().then(() => {
                setLoggedUser({
                  name: '',
                  email: '',
                  DOB: '',
                  profile: '',
                  provinceName: '',
                  website: '',
                  isAuthenticated: false,
                  isAdmin: false
                }); 
                enqueueSnackbar("You have been signed out successfully", { variant: 'info' });
                navigate("/login");    
            }).catch((error) => {
                navigate("/");
                enqueueSnackbar("Logout Error: " + error.message, { variant: 'warning' });
            });
        } catch (error) {
            navigate("/");
            enqueueSnackbar("Logout Error: " + error.message, { variant: 'warning' });
        } finally {
            setLoaded(true);
        }
    };

    return (
        <div className="d-flex flex-column align-items-center justify-content-center min-vh-100 text-center p-4">
            <Preloader show={!loaded} />
            <div className="card p-5 shadow-sm" style={{ maxWidth: '400px', borderRadius: '20px' }}>
                <div className="spinner-border text-primary mx-auto mb-3" role="status"></div>
                <h5 className="fw-bold mb-2">Signing Out...</h5>
                <p className="text-muted small mb-0">Safely ending your student portal session.</p>
            </div>
        </div>
    );
}
